module.exports = __webpack_public_path__ + "static/img/302.9e5f87c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201224/302.jpg
// module id = uWax
// module chunks = 0